import { render, staticRenderFns } from "./editBase.vue?vue&type=template&id=58991e4a&scoped=true&"
import script from "./editBase.vue?vue&type=script&lang=js&"
export * from "./editBase.vue?vue&type=script&lang=js&"
import style0 from "./editBase.vue?vue&type=style&index=0&id=58991e4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58991e4a",
  null
  
)

export default component.exports